export const ru = {
  "NAVIGATION": {
    "HOME": "Главная",
    "PORTFOLIO": "Портфель",
    "PROFILE": "Профиль"
  },
  "HOME_SCREEN": {
    "SEARCH": {
      "PLACEHOLDER": "Поиск в доступных сделках",
      "TITLE": "Поиск только в разделе доступных сделок"
    },
    "QUICK_FILTERS": {
      "TITLE": "Быстрые фильтры",
      "CAPTION": "Выберите категорию",
      "DEFI": "DeFi",
      "STAKING": "Стейкинг",
      "FARMING": "Фарминг",
      "LENDING": "Лендинг",
      "MINING": "Майнинг",
      "TRADING": "Трейдинг",
      "ALL": "Все",
      "STABLECOINS": "Стейблкоины",
      "DEPOSITS": "Депозиты",
      "DEXES": "DEX биржи"
    },
    "PREMIUM_DEALS": {
      "TITLE": "Премиум сделки",
      "CAPTION": "Лучшие сделки недели",
      "NO_DEALS": "Нет сделок",
      "NO_DEALS_AVAILABLE": "Нет доступных сделок",
      "GET_PREMIUM": "Получить Премиум",
      "APY": "Годовой процент",
      "NETWORK": "Сеть",
      "TOKEN_TYPE": "Тип токена"
    },
    "FILTERS": {
      "TITLE": "Фильтры",
      "FILTERS": "Фильтры",
      "SELECT_FILTERS": "Выберите фильтры",
      "APPLY": "Применить"
    },
    "AVAILABLE_DEALS": {
      "TITLE": "Доступные сделки",
      "CAPTION": "Новые рыночные возможности",
      "NO_DEALS": "Возможности не найдены"
    }
  },
  "PROFILE_SCREEN": {
    "SUBSCRIPTION_STATUS": {
      "TITLE": "Статус подписки",
      "CAPTION": "Детали вашей премиум-подписки",
      "ACTIVE": "АКТИВНА",
      "INACTIVE": "НЕАКТИВНА",
      "PERIOD": "Период",
      "EXPIRES": "Истекает",
      "PROGRESS": "Прогресс подписки",
      "NOT_STARTED": "Не начато"
    },
    "REFERRAL": {
      "TITLE": "Реферальная программа",
      "CAPTION": "Приглашайте друзей и зарабатывайте поинты",
      "RANK": "РАНГ",
      "TOTAL_REFERRALS": "Всего рефералов",
      "ACTIVE_REFERRALS": "Активные рефералы",
      "REFERRALS_BY_LEVEL": "Рефералы по уровням",
      "COPY": "Копировать",
      "POINTS_TO_NEXT_RANK": "{{points}} поинтов до следующего ранга"
    },
    "PREMIUM": {
      "TITLE": "Премиум подписка",
      "CAPTION": "Выберите план и получите доступ к премиум-функциям",
      "MONTHS": "месяцев",
      "BEST_VALUE": "Лучшая цена",
      "PAYMENT_METHOD": "Способ оплаты",
      "TELEGRAM_STARS": "Telegram Stars",
      "CRYPTO": "Криптовалюта",
      "YOU_SAVE": "Вы экономите",
      "PROCESSING": "Обработка...",
      "PAY_STARS": "Оплатить {{amount}} Stars",
      "PAY_CRYPTO": "Оплатить ${{amount}} в криптовалюте",
      "PAYMENT_SUCCESS": {
        "TITLE": "Оплата успешна",
        "MESSAGE": "Ваша подписка успешно активирована!"
      },
      "PAYMENT_ERROR": {
        "TITLE": "Ошибка оплаты",
        "MESSAGE": "Не удалось обработать платеж. Пожалуйста, попробуйте снова.",
        "STARS_INSUFFICIENT": "Недостаточно звезд для оплаты. Пожалуйста, пополните баланс звезд через @PremiumBot."
      },
      "PAYMENT_CANCELLED": {
        "TITLE": "Платеж отменен",
        "MESSAGE": "Вы отменили платеж. Попробуйте снова, когда будете готовы."
      },
      "PAYMENT_PENDING": {
        "TITLE": "Обработка платежа",
        "MESSAGE": "Ваш платеж обрабатывается. Пожалуйста, подождите."
      },
      "BUTTONS": {
        "OK": "OK",
        "CANCEL": "Отмена",
        "BUY_STARS": "Купить Stars"
      }
    },
    "FEATURES": {
      "EARLY_ACCESS": "Ранний доступ к Премиум сделкам с высоким APY",
      "EXCLUSIVE_DEFI": "Эксклюзивные DeFi возможности с APY до 80%",
      "NOTIFICATIONS": "Уведомления о новых Премиум сделках в реальном времени",
      "GUIDES": "Подробные пошаговые руководства и стратегии",
      "INSIGHTS": "Еженедельные рыночные обзоры и рекомендации"
    },
    "FOOTER": {
      "CONTACT": "Если у вас есть вопросы, свяжитесь с нами:",
      "EMAIL_COPIED": "Email адрес скопирован в буфер обмена",
      "SUPPORT_TITLE": "Поддержка",
      "SUPPORT_CAPTION": "Свяжитесь с нами, если у вас есть вопросы",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram"
    },
    "LANGUAGE": {
      "TITLE": "Настройки языка",
      "CAPTION": "Выберите предпочитаемый язык",
      "LANGUAGES": {
        "EN": "Английский",
        "RU": "Русский",
        "UK": "Украинский",
        "ES": "Испанский",
        "AR": "Арабский",
        "ZH": "Китайский"
      }
    }
  },
  "PORTFOLIO_STRATEGY_SCREEN": {
    "TITLE": "Стратегия портфеля",
    "SUBTITLE": "Обзор доступных стратегий портфеля",
    "STRATEGIES": {
      "CONSERVATIVE": {
        "NAME": "Сохранение капитала",
        "DESCRIPTION": "Низкорисковая стратегия, ориентированная на сохранение капитала через стейблкоины со стабильной доходностью",
        "RISK_LEVEL": "Низкий риск"
      },
      "MODERATE": {
        "NAME": "Денежный поток",
        "DESCRIPTION": "Низкорисковая стратегия, ориентированная на стабильный доход через стейблкоины и крупные криптовалюты",
        "RISK_LEVEL": "Низкий риск"
      },
      "BALANCED": {
        "NAME": "Сбалансированный",
        "DESCRIPTION": "Умеренно-рисковая сбалансированная стратегия, включающая стейблкоины, крупные криптовалюты и отобранные альткоины",
        "RISK_LEVEL": "Умеренный риск"
      },
      "AGGRESSIVE": {
        "NAME": "Рост",
        "DESCRIPTION": "Высокорисковая стратегия роста, ориентированная на крупные криптовалюты и перспективные альткоины",
        "RISK_LEVEL": "Высокий риск"
      }
    },
    "ASSET_GROUPS": {
      "STABLECOINS": "Стейблкоины",
      "BLUE_CHIPS": "Крупные монеты",
      "TOP_ALTCOINS": "Топ альткоины",
      "OTHER_ALTCOINS": "Другие альткоины",
      "INDICES": "Индексы"
    },
    "DETAILS": {
      "ASSETS": "Активы",
      "YIELD_STRATEGY": "Стратегия доходности",
      "APY_PROJECTION": "Прогноз APY"
    }
  },
  "ASSET_DETAIL_SCREEN": {
    "BACK": "Назад",
    "PROJECT_NOT_FOUND": "Проект не найден",
    "SETUP_STEPS": "Шаги настройки",
    "GO_TO_PROJECT": "Перейти к проекту",
    "STATS": {
      "APY": "Годовой процент"
    },
    "STEPS": {
      "PREPARE_WEB3_WALLET": {
        "TITLE": "Подготовка Web3 кошелька",
        "DESCRIPTION": "Установите и настройте Web3 кошелек, поддерживающий выбранную сеть. Например, установите MetaMask для сетей на базе Ethereum, Phantom для Solana или Sui Wallet для сети Sui. Убедитесь, что ваш кошелек правильно настроен и защищен."
      },
      "CONNECT_NETWORK": {
        "TITLE": "Подключение к сети",
        "DESCRIPTION": "Добавьте и подключитесь к нужной блокчейн-сети в вашем кошельке. Если сеть не добавлена автоматически, вам может потребоваться добавить её вручную, используя RPC URL сети, Chain ID и другие параметры сети. Убедитесь, что вы подключены к правильной сети перед продолжением."
      },
      "CHECK_GAS_BALANCE": {
        "TITLE": "Проверка баланса для комиссий",
        "DESCRIPTION": "Убедитесь, что у вас достаточно нативных токенов в кошельке для оплаты комиссий за транзакции (gas). Для сетей Ethereum нужен ETH, для Solana - SOL, для Sui - SUI. Точная необходимая сумма будет зависеть от загруженности сети и сложности транзакции."
      },
      "PREPARE_ASSETS": {
        "TITLE": "Подготовка активов",
        "DESCRIPTION": "Переведите или приобретите конкретные токены, которые вы хотите инвестировать (например, USDC, USDT или DAI) на ваш подключенный кошелек. Убедитесь, что токены находятся в правильной сети - некоторые токены существуют в нескольких сетях, но не могут быть напрямую переведены между ними."
      }
    }
  },
  "ERROR_SCREEN": {
    "TITLE": "Упс! Что-то пошло не так",
    "DEFAULT_MESSAGE": "Произошла ошибка. Пожалуйста, попробуйте позже.",
    "RETRY_BUTTON": "Попробовать снова",
    "SPECIFIC_ERRORS": {
      "DOCKER": "Сервис временно недоступен. Пожалуйста, попробуйте через несколько минут.",
      "NETWORK": "Проблема с подключением к сети. Проверьте ваше интернет-соединение.",
      "SERVICE": "Сервис временно недоступен. Наши специалисты уже работают над решением.",
      "DATABASE": "Проблема с доступом к данным. Пожалуйста, попробуйте позже."
    }
  }
}; 